import {
  AttendanceCustomTimeRangeDayEnum,
  AttendanceCustomTimeRangeDayEnum as DayEnum,
} from 'generated/resources/graphql'

import { CustomTimeRange } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

export type ActionTypes =
  | 'OPEN_BASE_CREATE_TIME_RANGE'
  | 'OPEN_CUSTOM_CREATE_TIME_RANGE'
  | 'OPEN_BASE_EDIT_TIME_RANGE'
  | 'OPEN_CUSTOM_EDIT_TIME_RANGE'
  | 'OPEN_BASE_DELETE_TIME_RANGE'
  | 'OPEN_CUSTOM_DELETE_TIME_RANGE'
  | 'CLEAR'

export enum CustomTimeRangeAction {
  createOpen = 'create_open',
  editOpen = 'edit_open',
  deleteOpen = 'delete_open',
}

export type Layout = 'base' | 'custom'

export interface Action {
  type: ActionTypes
  customTimeRanges?: CustomTimeRange[]
  timeRangeIds?: string[]
  dayType?: AttendanceCustomTimeRangeDayEnum
}

export interface State {
  layout: Layout | ''
  action: string
  regularCustomTimeRange?: CustomTimeRange
  overtimeCustomTimeRange?: CustomTimeRange
  timeRangeIds?: string[]
  dayType?: AttendanceCustomTimeRangeDayEnum
  customTimeRangeDispatch: React.Dispatch<Action>
  dayEnums: DayEnum[]
}

const initialState: State = {
  action: 'close',
  layout: 'base',
  regularCustomTimeRange: undefined,
  overtimeCustomTimeRange: undefined,
  timeRangeIds: [],
  dayType: 'monday',
  dayEnums: [],

  customTimeRangeDispatch: () => {},
}

export type Dispatch = (arg0: Action) => void

const reducer = (state: State, action: Action): State => {
  const { type, customTimeRanges, timeRangeIds, dayType } = action
  switch (type) {
    case 'OPEN_BASE_CREATE_TIME_RANGE':
      return {
        ...state,
        layout: 'base',
        action: CustomTimeRangeAction.createOpen,
        ...(dayType && { dayType: dayType }),
      }
    case 'OPEN_CUSTOM_CREATE_TIME_RANGE':
      return {
        ...state,
        layout: 'custom',
        action: CustomTimeRangeAction.createOpen,
        ...(dayType && { dayType: dayType }),
      }
    case 'OPEN_BASE_EDIT_TIME_RANGE':
      return {
        ...state,
        layout: 'base',
        action: CustomTimeRangeAction.editOpen,
        ...(customTimeRanges && {
          regularCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'regular'
          ),
          overtimeCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'overtime'
          ),
        }),
      }
    case 'OPEN_CUSTOM_EDIT_TIME_RANGE':
      return {
        ...state,
        layout: 'custom',
        action: CustomTimeRangeAction.editOpen,
        ...(customTimeRanges && {
          regularCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'regular'
          ),
          overtimeCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'overtime'
          ),
        }),
      }

    case 'OPEN_BASE_DELETE_TIME_RANGE':
      return {
        ...state,
        layout: 'base',
        action: CustomTimeRangeAction.deleteOpen,
        timeRangeIds: timeRangeIds || [],
        dayType: dayType,
      }

    case 'OPEN_CUSTOM_DELETE_TIME_RANGE':
      return {
        ...state,
        layout: 'custom',
        action: CustomTimeRangeAction.deleteOpen,
        timeRangeIds: timeRangeIds || [],
      }

    case 'CLEAR':
      return { ...state, layout: '', action: '', dayType: 'monday' }
    default:
      return initialState
  }
}

export { reducer, initialState }
